<nav class="navbar">
  <div class="navbar-container">
    <a routerLink="/" class="navbar-logo">
      <img src="assets/full-logo-transparent.svg" alt="Hebern Logo" class="logo-img" />
    </a>
    <ul class="navbar-menu">
      @for (item of navItems; track item.path) {
      <li class="navbar-item">
        <a 
          [routerLink]="item.path" 
          routerLinkActive="active" 
          [routerLinkActiveOptions]="{ exact: item.path === '/' }"
          class="navbar-link">
          {{ item.label }}
        </a>
      </li>
      }
      <li class="navbar-item">
        @if (auth.isAuthenticated()) {
        <div class="account-menu">
          <button
            type="button"
            class="navbar-link navbar-link--account account-menu-trigger"
            [class.active]="isAccountRouteActive()"
            [class.account-menu-trigger--open]="isAccountMenuOpen"
            [attr.aria-expanded]="dashboards().length > 1 ? isAccountMenuOpen : null"
            (click)="openAccountDashboard()"
          >
            Account
            @if (dashboards().length > 1) {
            <span
              class="account-caret"
              [class.account-caret--open]="isAccountMenuOpen"
              aria-hidden="true"
            ></span>
            }
          </button>
          @if (dashboards().length > 1 && isAccountMenuOpen) {
          <div class="account-menu-panel">
            @for (dashboard of dashboards(); track dashboard.role) {
            <a
              [routerLink]="dashboard.path"
              routerLinkActive="active"
              class="account-menu-link"
              (click)="closeAccountMenu()"
            >
              {{ dashboard.label }}
            </a>
            }
          </div>
          }
        </div>
        } @else {
        <a
          routerLink="/login"
          routerLinkActive="active"
          class="navbar-link navbar-link--account"
        >
          Log In
        </a>
        }
      </li>
    </ul>
  </div>
</nav>
